import { FieldSchema } from "../../../Schema";

export const functionalLocation: FieldSchema = {
  grid: {
    displayed: true,
    order: 38,
    sortable: false,
  },
  name: "functionalLocation",
  display: {
    displayed: true,
  },
  form: { label: "Functional location" },
};
